import { Box, MenuItem, Typography } from "@mui/material";
import FormCurrencyInput from "@/components/FormCurrencyInput";
import FormSelect from "@/components/FormSelect";
import dayjs from "dayjs";
import { getQuartersForYear } from "@/utils/getQuartersForYear";
import { getMonthsForQuarter } from "@/utils/getMonthsForQuarter";
import {Control} from "react-hook-form";
import {FC} from "react";

type Props = {
    control: Control<any, any>;
    performanceYear?: string;
}

const PerformanceReportFields:FC<Props> = ({
  control,
  performanceYear,
}) => {
  return (
    <>
      <FormCurrencyInput
        name="quarterlyPerformanceIncentiveValue"
        control={control}
        label="Quarterly performance incentive value"
        placeholder="$00.00"
        maxValue={100000}
        defaultValue={""}
        controlProps={{
          rules: { required: "Required" },
        }}
      />
      <FormSelect
        control={control}
        name="performanceYear"
        label="Year"
        placeholder="Year"
        controlProps={{
            rules: { required: "Required" },
        }}
      >
        {Array.from({ length: 3 }, (_, i) => dayjs().year() - i).map((year) => (
          <MenuItem key={year} value={String(year)}>
            {year}
          </MenuItem>
        ))}
      </FormSelect>
      <FormSelect
        control={control}
        name="quarterName"
        label="Quarter"
        placeholder="Quarter"
        disabled={!performanceYear}
        controlProps={{
            rules: { required: "Required" },
        }}
      >
        {getQuartersForYear(Number(performanceYear)).map((quarter) => (
          <MenuItem key={quarter} value={quarter}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography fontWeight={600}>{quarter}</Typography>
              <Typography variant="body2" color="text.secondary">
                {getMonthsForQuarter(quarter).join(", ")}
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </FormSelect>
    </>
  );
};

export default PerformanceReportFields;